import { render } from "./CouponField.vue?vue&type=template&id=317a3560"
import script from "./CouponField.vue?vue&type=script&lang=js"
export * from "./CouponField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__